<style scoped lang="scss">
</style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" @expandChange="expandChange">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('zidianleixing')">
						<el-select filterable :clearable="true" v-model="yt.conditions.id">
							<el-option v-for="(item, index) in list" :key="index" :label="item.id" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zidianbianma')">
						<el-select filterable :clearable="true" v-model="yt.conditions.typeId">
							<el-option v-for="(item, index) in list" :key="index" :label="item.typeId"
								:value="item.typeId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zidianzhi')">
						<el-select filterable :clearable="true" v-model="yt.conditions.value">
							<el-option v-for="(item,index) in list" :key="index" :label="item.name" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain>
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary" v-if="ids == null">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
				</el-button> -->
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/config/dictType/delete')">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>
			<!-- 底部插槽 -->
			<template #footer>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('zidianleixingmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zidianleixingbianma')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>

				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.req('POST','/web/config/dictType/create')" type="primary">确认
					</el-button>
					<el-button size="mini" @click="yt.isShowEditDialog = false">取消</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('zidianleixingmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zidianleixingbianma')">
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.req('POST','/web/config/dictType/update')" type="primary">确认
					</el-button>
					<el-button size="mini" @click="yt.isShowEditDialog = false">取消</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	
	export default {
		name: 'admin_global_dictionary_list',
		
		data() {
			return {
				list: [],
				curd: {
					columns: [

						{
							label: 'ID',
							prop: 'id',

						},
						{
							label: 'zidianleixing',
							prop: 'name',

						},
						{
							label: 'zidianbainma',
							prop: 'code'
						},

						{
							label: 'caozuo',
							type: 'slot',
							width: 130,
							fixed: 'right',
						},
					],
				},
			};
		},
		created() {
			// table列表接口请求参数
			this.yt.conditions = {
				platform: 1,
				pageNum: 1,
				pageSize: 10
			}
			// 初始化table(请求接口地址)
			this.initCurd('/web/config/dictType/page', 'rows');

		},
		methods: {

			// 重置
			clear() {
				this.yt.conditions = {
					platform: 1
				}
				this.get(1)
			},

			expandChange(a, b) {
				console.log(a, b)
			},


		},
	};
</script>
